
export const REQUEST_ADDRESPONDENTANSWER= 'REQUEST_ADDRESPONDENTANSWER';
export const ADDRESPONDENTANSWER_RECEIVED = 'ADDRESPONDENTANSWER_RECEIVED';